import { useTranslator } from 'tradera/lang/translate';

export const TopDescription = ({ titleKey, description, isError, classes }) => {
    const { t } = useTranslator();

    return (
        <div className="text-center">
            <h1
                className={`mb-0 text-styled heading-madrid ${
                    isError ? 'text-danger' : ''
                } ${classes || ''}`}>
                {t(titleKey)}
            </h1>
            <p>{t(description)}</p>
        </div>
    );
};
